import type { ApiError } from '@/types/api.types';

type TranslateFn = (key: string) => string;

export function mapChartTemplateError(
  error: ApiError,
  t: TranslateFn,
  fallbackKey: string,
): string {
  switch (error.code) {
    case 'TEMPLATE_NOT_FOUND':
      return t('chartTemplates.errors.notFound');
    case 'VERSION_NOT_FOUND':
      return t('chartTemplates.errors.versionNotFound');
    case 'VALIDATION_ERROR':
      return t('chartTemplates.errors.validationError');
    case 'INTERNAL_SERVER_ERROR':
      return t('chartTemplates.errors.serverError');
    default:
      return t(fallbackKey);
  }
}
